
import { default as reactHotToast, ToastOptions } from "react-hot-toast";
import { Logger } from "#/lib/logging";
import { serializeError } from "#/utils/errors";

export type Toast =
  & Pick<typeof reactHotToast, "success" | "loading" | "custom" | "dismiss" | "remove" | "promise">
  & {
    error(message: string, errorForLogging?: unknown, options?: ToastOptions): string
  };

export const toast: Toast = {
  error: (message, errorForLogging, options) => {
    let error: Error;
    if (errorForLogging instanceof Error) {
      error = errorForLogging;
    } else if (errorForLogging != null) {
      error = JSON.parse(serializeError(errorForLogging));
    } else {
      error = new Error(message);
    }
    Logger.error({ message: `(ERROR TOAST) ${message}`, error });
    return reactHotToast.error(message, options as ToastOptions);
  },
  success: reactHotToast.success,
  loading: reactHotToast.loading,
  custom: reactHotToast.custom,
  dismiss: reactHotToast.dismiss,
  remove: reactHotToast.remove,
  promise: reactHotToast.promise
};